import { GitError } from '../wasm-git-worker-errors.model';
import { GitErrorStatusCode } from './errors.enum';

export class UnprocessableJSONGitError extends GitError {
  constructor(filePath: string, append = true) {
    super(append ? `Unprocessable JSON file at "${filePath}"` : filePath);
  }

  readonly gitErrorCode = GitErrorStatusCode.UnprocessableJSON;
}
